import { createSlice } from '@reduxjs/toolkit';
import apiClient from '@miroculus/api-client';
const initialState = {
    cameras: [],
    cameraId: '',
    cameraOn: false,
    calibration: [],
};
const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setCameraId: (state, action) => {
            state.cameraId = action.payload;
        },
        updateCameras: (state, action) => {
            state.cameras = action.payload;
        },
        toggleCamera: (state) => {
            state.cameraOn = !state.cameraOn;
        },
        toggleHeaterOpened: (state, action) => {
            const heater = state.calibration.find((h) => h.name === action.payload);
            if (heater) {
                heater.opened = !heater.opened;
            }
        },
        updateHeaterParam: (state, action) => {
            const { heaterName, param, value } = action.payload;
            const heater = state.calibration.find((h) => h.name === heaterName);
            if (heater) {
                heater[param] = value;
            }
        },
    },
});
// Internal actions
const { updateHeaterParam } = settingsSlice.actions;
// Export actions (setCameraId exported for testing reducer directly)
export const { setCameraId, updateCameras, toggleCamera, toggleHeaterOpened } = settingsSlice.actions;
// Action that also persists to storage (thunk to handle side effect)
export const updateCameraId = (cameraId) => (dispatch) => {
    apiClient.storage.set('cameraId', cameraId);
    dispatch(setCameraId(cameraId));
};
// Heater parameter update actions (maintain backward compatibility)
export const updateHeaterP = (heaterName, value) => updateHeaterParam({ heaterName, param: 'p', value });
export const updateHeaterI = (heaterName, value) => updateHeaterParam({ heaterName, param: 'i', value });
export const updateHeaterD = (heaterName, value) => updateHeaterParam({ heaterName, param: 'd', value });
export const updateHeaterGain = (heaterName, value) => updateHeaterParam({ heaterName, param: 'gain', value });
export const updateHeaterOffset = (heaterName, value) => updateHeaterParam({ heaterName, param: 'offset', value });
// Async thunk
export const loadCameras = (cameras) => (dispatch, getState) => {
    dispatch(updateCameras(cameras));
    const cameraId = getState().settings.cameraId;
    const index = cameras.map((camera) => camera.id).indexOf(cameraId);
    if (cameras && cameras.length) {
        if (index > -1) {
            dispatch(updateCameraId(cameraId));
        }
        else {
            dispatch(updateCameraId(cameras[0].id));
        }
    }
};
// Export reducer as default
export default settingsSlice.reducer;
